<template>
  <v-flex md8 offset-md2>
    <v-snackbar
      v-model="snackbar"
      color="error"
      top
      xs12
      :multi-line="true"
      :timeout="10000"
    >
      {{error}}
    </v-snackbar>
    <v-snackbar
      v-model="successSnack"
      color="success"
      top
      xs12
      :multi-line="true"
      :timeout="10000"
    >
      This concern is now deleted
    </v-snackbar>
    <v-dialog
      v-model='deleteShow'
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">{{$t('global.areYouSure')}}</v-card-title>
        <v-card-text>{{$t('service.areYouSure')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="deleteId = null"
          > {{$t('global.cancel')}} </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="deleteService()"
          > {{$t('global.delete')}} </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <h1>{{$t('service.availableServices')}}</h1>
    <v-layout row>
      <v-flex>
        <v-card dark>
          <v-list two-line dense>
            <v-list-group
              v-for="(service, index) in services"
              v-model="service.active"
              :key="index + ' ' + service.title['en-US']"
              no-action
            >
              <v-list-item slot="activator">
                <v-btn small icon v-on:click.stop="deleteId = service.id">
                  <v-icon class="transparent white--text"> delete_forever </v-icon>
                </v-btn>
                <v-btn small icon v-on:click.stop="$router.push('/service/' + service.id)">
                  <v-icon class="transparent white--text"> edit </v-icon>
                </v-btn>
                <v-list-item-content>
                  <v-list-item-title>{{ service.title['en-US'] || service.title }}</v-list-item-title>
                  <v-list-item-subtitle v-if="service.title"> {{(service.description['en-US'] ? service.description['en-US'].short || service.description['en-US'].long : "")}} </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="!service.products.length">
                <v-list-item-content>
                  <v-list-item-title>{{ $t("service.freeAnswer") }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-for="product in service.products"
                :key="index + ' ' + product"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ idToProduct(product) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import axios from 'axios'
import { urlDev, urlProd } from '../settings/settings.json'

const apiUrl = process.env.NODE_ENV === 'production' ? urlProd : urlDev

axios.defaults.baseURL = apiUrl
var instance = axios.create({
  headers: { 'Authorization': 'Bearer ' + localStorage.token }
}); export default {
  props: ['products', 'services'],
  data () {
    return {
      deleteId: '',
      snackbar: false,
      successSnack: false,
      error: 'Error'
    }
  },
  methods: {
    idToProduct: function (value) {
      var output = null
      this.products.forEach(function (element) {
        if (value === element.id) { output = element.title['en-US'] }
      })
      return (output)
    },
    deleteService: function () {
      instance.delete('/' + this.$session.get('brand') + '/service/' + this.deleteId)
        .then(() => { this.deleteId = null; this.$emit('reload'); this.successSnack = true })
        .catch(() => {
          this.snackbar = true
          this.error = "The suppression of this service failed, try again later"
        })

    }
  },
  computed: {
    deleteShow: function () {
      return !!this.deleteId
    }
  }
}
</script>
<style>
.v-list-item{
  width: 92%;
}
</style>
